import React, { useState, useEffect } from 'react';
import { getLanguageFromUrl } from '../utils/languageUtils';
import './ViewSelection.css';

const ViewSelection = ({ selectedView, setSelectedView, product, className }) => {
  const [views, setViews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Helper function to get view ID from view object or string
  const getViewId = (view) => {
    if (!view) return '';
    if (typeof view === 'string') {
      return view; // Old format: simple string
    }
    if (typeof view === 'object' && view.id) {
      return view.id; // New format: object with id
    }
    return '';
  };
  
  // Helper function to get the full view object by ID
  const getFullViewObject = (viewId) => {
    if (!product) return viewId;
    const productViews = product.views || product.Views || [];
    return productViews.find(v => getViewId(v) === viewId) || viewId;
  };

  // Helper function to get view name in current language
  const getViewName = (view) => {
    if (!view) return '';
    if (typeof view === 'string') {
      return view; // Old format: simple string
    }
    if (typeof view === 'object') {
      if (view.name && typeof view.name === 'object') {
        // New format: object with name translations
        const currentLang = getLanguageFromUrl();
        return view.name[currentLang] || view.name['en'] || view.name['cn'] || view.id || '';
      } else if (view.name && typeof view.name === 'string') {
        // Intermediate format: object with string name
        return view.name;
      } else if (view.id) {
        // Fallback to id if no name
        return view.id;
      }
    }
    return '';
  };

  useEffect(() => {
    const loadViews = () => {
      try {
        if (!product) {
          
          setViews([]);
          setIsLoading(false);
          return;
        }

        // Get views from the product object, handle both lowercase and uppercase property names
        const productViews = product.views || product.Views || [];
        
        
        
        // Transform the views array to match the expected format
        const formattedViews = productViews.map(view => {
          const id = getViewId(view);
          const name = getViewName(view);
          return {
            id: id,
            label: name,
            icon: null
          };
        });

        
        setViews(formattedViews);
        
        // If there's no selected view yet and we have views, select the first one with full object
        if (!selectedView && formattedViews.length > 0) {
          const firstViewId = formattedViews[0].id;
          const fullView = getFullViewObject(firstViewId);
          setSelectedView(fullView);
        }
      } catch (error) {
        console.error('Error loading product views:', error);
        setViews([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadViews();
  }, [product, selectedView, setSelectedView]);

  // Debug log the component state
  
  
  if (isLoading) {
    
    return null; // Don't render anything if loading
  }
  
  if (views.length === 0) {
    
    return null; // Don't render if no views
  }
  
  // Only hide if there's exactly one view
  if (views.length === 1) {
    
    return null;
  }
  
  // HeaderBar will handle all navigation and view UI
  return null;
};

export default ViewSelection;
